/* Nividas PDP sticky ATC — May 2026.
   Show when the inline .nv-pdp-atc__btn is off-screen, hide when it scrolls
   back into view. Clicks on the sticky's ATC proxy through to the inline
   ATC so the same form submits. Size pills proxy through to the inline
   size radios so the existing variant-change cascade handles price/stock. */

(function () {
  'use strict';

  // Mirror of snippets/nv-money.liquid — produces "1299 SEK" or "1299.50 SEK".
  function fmt(section, cents) {
    if (cents == null) return '';
    var currency = (section && section.dataset && section.dataset.currency) || 'SEK';
    var negative = cents < 0;
    var abs = negative ? -cents : cents;
    var whole = Math.floor(abs / 100);
    var rem = abs % 100;
    // Thousands grouped with a comma, like the store's money format.
    var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (rem !== 0) out += '.' + (rem < 10 ? '0' : '') + rem;
    return (negative ? '-' : '') + out + ' ' + currency;
  }

  function findSection(el) {
    return el && el.closest('[data-section-type="nv-pdp"]');
  }

  function variantsFor(section) {
    var ta = section && section.querySelector('[data-variant-json]');
    if (!ta) return [];
    try { return JSON.parse(ta.textContent.trim()); } catch (e) { return []; }
  }

  function currentVariant(section) {
    if (!section) return null;
    var variants = variantsFor(section);
    // Source of truth = the hidden product <select>. nv-pdp-info.js keeps
    // its value synced whenever ANY variant input changes (size, strength,
    // future options), so we can read the current variant id from there
    // regardless of which option types this product has.
    var productSelect = section.querySelector('[data-product-select]');
    if (productSelect && productSelect.value) {
      var match = variants.find(function (v) { return String(v.id) === String(productSelect.value); });
      if (match) return match;
    }
    // Fallback to the first available variant if the select isn't populated yet.
    return variants.find(function (v) { return v.available; }) || variants[0] || null;
  }

  function updateSticky(sticky) {
    var section = findSection(sticky);
    if (!section) return;
    var v = currentVariant(section);
    if (!v) return;

    var sizeEl   = sticky.querySelector('[data-nv-pdp-sticky-size]');
    var priceEls = sticky.querySelectorAll('[data-nv-pdp-sticky-price]');
    var atcBtn   = sticky.querySelector('[data-nv-pdp-sticky-btn]');
    var label    = sticky.querySelector('[data-nv-pdp-sticky-label]');

    if (sizeEl) sizeEl.textContent = v.option1 || v.title || '';

    // When the PDP's Sun / Prescription toggle is in the prescription state,
    // the bar advertises the Rx flow, not this frame's own price and cart
    // action. Leave those alone — nv-pdp-rx-toggle.js owns them while that
    // state is active, and overwriting here made the label snap back to
    // "Add to cart" on every variant update.
    // Two price elements (mobile top-row + desktop sub-line, only one
    // visible at a time per breakpoint) — update both so the visible one
    // is correct. The price is the frame price in both lens states, so it
    // always tracks the variant.
    priceEls.forEach(function (el) {
      el.setAttribute('data-frame-cents', v.price);
      el.innerHTML = fmt(section, v.price);
    });
    // Prescription view adds the lens to the frame price.
    if (window.nvRxRenderPrices) window.nvRxRenderPrices();
    if (atcBtn) atcBtn.disabled = !v.available;

    // The label is the exception: while the PDP's Sun / Prescription toggle
    // is in the prescription state, nv-pdp-rx-toggle.js owns it. Without
    // this guard it snapped back to "Add to cart" on every variant update.
    var rxActive = sticky.getAttribute('data-rx-state') === 'clear';
    if (label && !rxActive) {
      label.textContent = v.available ? 'Add to cart' : 'Sold out';
    }

    // Mirror active state on size pills.
    sticky.querySelectorAll('[data-nv-pdp-sticky-size-btn]').forEach(function (b) {
      var on = b.dataset.sizeValue === (v.option1 || v.title);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }

  function bindSizePills(sticky) {
    var section = findSection(sticky);
    if (!section) return;
    sticky.querySelectorAll('[data-nv-pdp-sticky-size-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Find the inline size radio with the same value and click it.
        // The inline change handler does the heavy lifting (updates price,
        // stock, hidden product-select, etc.) — we just react to it.
        var val = btn.dataset.sizeValue;
        var radios = section.querySelectorAll('[data-nv-pdp-size-input]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === val) {
            radios[i].click();
            break;
          }
        }
      });
    });
  }

  function watchInlineForChange(sticky) {
    var section = findSection(sticky);
    if (!section) return;
    section.querySelectorAll('[data-nv-pdp-size-input]').forEach(function (r) {
      r.addEventListener('change', function () { updateSticky(sticky); });
    });
  }

  function init(stickyEl) {
    if (!stickyEl || stickyEl.dataset.nvBound === '1') return;
    stickyEl.dataset.nvBound = '1';

    var inlineBtn = document.querySelector('.nv-pdp-atc__btn');
    if (!inlineBtn) return;

    // Show / hide via IntersectionObserver — sticky visible iff the inline
    // ATC is OFF-screen. rootMargin lifts the threshold so the sticky
    // appears just before the inline ATC fully leaves the viewport.
    var io = new IntersectionObserver(
      function (entries) {
        var visible = !entries[0].isIntersecting;
        stickyEl.classList.toggle('is-visible', visible);
        stickyEl.setAttribute('aria-hidden', String(!visible));
      },
      { threshold: 0.05, rootMargin: '0px 0px -80px 0px' }
    );
    io.observe(inlineBtn);

    // Proxy ATC click through to inline button (single submission path).
    var stickyBtn = stickyEl.querySelector('[data-nv-pdp-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (inlineBtn.disabled) return;
        inlineBtn.click();
      });
    }

    bindSizePills(stickyEl);
    watchInlineForChange(stickyEl);
    updateSticky(stickyEl);
  }

  function initAll() {
    document.querySelectorAll('[data-nv-pdp-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
